import { isUserAuthorized } from '../utils/helper';
import PrivateRoutes from './PrivateRoutes/PrivateRoutes';
import PublicRoutes from './PublicRoutes/PublicRoutes';

export const Routers = () => {
    return isUserAuthorized() ? <PrivateRoutes /> : <PublicRoutes />;
};
